import { useCurrentUser } from "@indietabletop/appkit";
import { useEffect } from "react";

function useScrollbarVisibility() {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser?.prefersScrollbarVisibility === "ALWAYS") {
      document.body.classList.add("prefers-scrollbar-visibility-always");
    }

    return () => {
      document.body.classList.remove("prefers-scrollbar-visibility-always");
    };
  }, [currentUser?.prefersScrollbarVisibility]);
}

export function ScrollbarVisibility() {
  useScrollbarVisibility();

  return null;
}
